import { render, staticRenderFns } from "./Chengdu.vue?vue&type=template&id=5d538653&scoped=true"
import script from "./Chengdu.vue?vue&type=script&lang=js"
export * from "./Chengdu.vue?vue&type=script&lang=js"
import style0 from "./Chengdu.vue?vue&type=style&index=0&id=5d538653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d538653",
  null
  
)

export default component.exports